<div
  #overlayOrigin
  class="overlay-origin">
  <coin-v2-text-input
    #searchInputElement
    [loading]="loading()"
    [errorMessage]="errorTooltip()"
    [formControl]="searchControl"
    [inputDebounce]="300"
    [placeholder]="placeholder()"
    [label]="label()"
    [clearable]="!!viewValue() && !disabled()"
    [icon]="icon()"
    [class.has-value]="!!viewValue()"
    (blur)="markAsTouched()"
    (customClear)="clearValue()"></coin-v2-text-input>
</div>

@let isResultsOpen = isSearchResultVisible() && !loading() && !!searchControl.value;
<!-- clientWidth forces a layout on every check, so it is only read while the overlay uses it -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="isResultsOpen"
  [cdkConnectedOverlayWidth]="isResultsOpen ? overlayOrigin.clientWidth : undefined"
  [cdkConnectedOverlayDisableClose]="true"
  (detach)="handleDetach()">
  <div
    class="search-results"
    aria-label="search-box-results">
    @if (results?.length > 0) {
      <div class="scroll-container">
        @for (result of results; track result) {
          <div
            class="result"
            (click)="selectResult(result.value)">
            <ng-container *ngTemplateOutlet="result.template"></ng-container>
          </div>
        }
      </div>
    } @else {
      <div class="no-results-container">
        <p>{{ noResultsTextKey() | translate }}</p>
      </div>
    }
  </div>
</ng-template>
